import { Button, Grid, TextField, Typography } from '@/ui';

import type { CoachProfile } from '@/types';
import type { ChangeEvent, FC, KeyboardEvent } from 'react';

import LockCard from '@/components/Profile/Card/Lock';
import Cal from '@/components/Profile/Coach/Edit/Account/Hours/Cal';

interface EditCoachAdminSettingsTopProps {
  calendarUrl?: string;
  capacity?: number;
  email: string;
  isActive: boolean;
  schedulingProvider?: CoachProfile['schedulingProvider'];
  onActivateChange: (isActivated: boolean) => void;
  onCapacityChange: (value?: number) => void;
  onRemove: () => void;
}

const EditCoachAdminSettingsTop: FC<EditCoachAdminSettingsTopProps> = ({
  isActive = false,
  email,
  calendarUrl,
  capacity = 0,
  schedulingProvider,
  onActivateChange,
  onCapacityChange,
  onRemove,
}) => {
  const onActivate = () => onActivateChange(!isActive);
  const onCapacity = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
    onCapacityChange(parseInt(e.target.value || '0', 10));
  const onCapacityKeyUp = (e: KeyboardEvent<HTMLDivElement>) => {
    if (!/[0-9]/u.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Grid spacing={4} container>
      <Grid md={5} xs={12} item>
        <Typography className="mb-2" variant="h4">
          Admin settings
        </Typography>
        <Typography variant="body1">
          Account status: {isActive ? 'Enabled' : 'Disabled'}
        </Typography>
        <Typography className="mt-2" variant="body2">
          {schedulingProvider === 'moments'
            ? "Disabling the account ends active coach assignments and deletes all future coaching sessions from the coach's and members' calendars."
            : 'Disabling the account ends active coach assignments and deletes all future Mento Calendar sessions. Cal.com bookings must be cancelled manually.'}
        </Typography>
        <div className="mt-4 flex flex-row gap-2">
          <Button
            color={isActive ? 'error' : 'primary'}
            variant="contained"
            onClick={onActivate}
          >
            {isActive ? 'Disable account' : 'Enable account'}
          </Button>
          {!isActive && (
            <Button color="error" variant="contained" onClick={onRemove}>
              Remove coach
            </Button>
          )}
        </div>
      </Grid>
      <Grid className="mt-1 flex flex-col gap-3" md={7} xs={12} item>
        <LockCard icon="mail" title={email} />
        <Cal
          schedulingProvider={schedulingProvider}
          username={calendarUrl ?? ''}
          hideAvailability
        />
        <div className="mt-2 flex flex-col gap-4">
          <TextField
            label="Capacity"
            placeholder="Capacity"
            value={capacity}
            onChange={onCapacity}
            onKeyUp={onCapacityKeyUp}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default EditCoachAdminSettingsTop;
